import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  width: 100%;
  background: ${Colors.background_secondary};
  border-radius: 6px;
  padding: 26px 20px 17px 19px;
  max-width: 100vw;
  overflow: hidden;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
`;

const TopElementContainer = styled.div`
  background: ${Colors.BG_Header_Card};
  color: ${Colors.text_on_primary};
  margin: -26px -20px -25px -19px;
  padding-left: 19px;
  padding-right: 19px;
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

const LastDaysText = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 18px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.01em;
`;

const InformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const ListWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TextRightMoney = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: ${Colors.text_primary};
`;

export default {
  Container,
  TopElementContainer,
  Title,
  InformationContainer,
  LastDaysText,
  ListWrapper,
  TextRightMoney,
};
